<template>
  <div :class="{ 'page-index': isSubmissionPage }">
    <b-row class="justify-content-md-center mx-0">
      <b-col v-if="showMainContent" lg="8">
        <base-bread-crumb :items="breadcrumbs" />

        <h5 v-if="learningUnit" class="display-4 font-weight-bold mb-4 header__lu-title">
          {{ learningUnit.name }}
        </h5>
        <div v-if="learningUnit.level_type" class="text-primary font-weight-bold my-4">
          <span class="mr-1"
            ><img
              :src="
                learningUnit.level_type === 'CAREER_SPECIFIC'
                  ? require('@/assets/learning-unit-types/specific.svg')
                  : require('@/assets/learning-unit-types/academic.svg')
              "
              style="height: 16px"
            />
          </span>
          <span class="text__mc-type">{{
            learningUnit.level_type === 'CAREER_SPECIFIC' ? 'Career Specific' : 'Academic Focused'
          }}</span>
        </div>
        <!-- <b-button
            v-if="isModeLearnVerify && isPageVerifyCompetency"
            variant="outline-primary"
            class="mb-3 btn__start-learning"
            @click="goToLearn"
          >
            Start learning
          </b-button> -->

        <div ref="text__compentency-title" class="text__compentency-title mb-2">
          <b>Competency</b>
        </div>

        <base-text-editor-display>
          <div
            v-if="learningUnit && learningUnit.competency_detail"
            ref="text__compentency-description"
            v-safe-html="learningUnit.competency_detail"
            class="text__compentency-description text-pre-line mb-5"
          ></div>
        </base-text-editor-display>

        <!-- What would you do next section -->

        <!-- <ultimate-learning-outcome
            v-if="learningUnit"
            class="mb-3 container__ultimate-lo"
            :learningUnit="learningUnit"
            disabled
          /> -->

        <!-- <div
            class="d-flex flex-column align-items-center justify-content-center mb-5"
          >
            <h5 class="font-weight-bold mb-3 header__subtitle">
              Demonstrate your abilities or enhancing your skills
            </h5>
            <b-button-group>
              <b-button
                :variant="variantButtonPageSubmitEvidence"
                :to="pageSubmitEvidence"
                >Evaluation Assessment</b-button
              >
    
              <b-button
                :variant="variantButtonPageLearningFeed"
                :to="pageLearningFeed"
                >Learning</b-button
              >
            </b-button-group>
          </div> -->

        <router-view></router-view>
      </b-col>

      <router-view
        v-else
        :can-create-new-submission="canCreateNewSubmission"
        @fetch-complete="isShowBuyQuota = true"
      ></router-view>
    </b-row>
  </div>
</template>

<script>
import { feedMixin } from '@/mixins/feedMixin';
import LearningUnit from '@/models/LearningUnit';
import Section from '@/models/Section';
import BaseBreadCrumb from '@/components/base-components/BaseBreadCrumb';
// import UltimateLearningOutcome from "@/components/LearningOutcome/UltimateLearningOutcome";
import { userInfoMixin } from '@/mixins';
import Application from '@/models/Application';
import BaseTextEditorDisplay from '@/components/base-components/BaseTextEditorDisplay';
import EvidenceSubmission from '@/models/EvidenceSubmission';

export default {
  components: {
    BaseBreadCrumb,
    BaseTextEditorDisplay
    // UltimateLearningOutcome,
  },
  mixins: [feedMixin, userInfoMixin],

  data() {
    return {
      isShowBuyQuota: false
    };
  },
  computed: {
    showMainContent() {
      return !this.isSubmissionPage && !this.isDeniedPage;
    },

    isSubmissionPage() {
      return this.$route.name === 'learning-unit/verify';
    },

    isDeniedPage() {
      return this.$route.name === 'learning-unit/submission-denied';
    },
    learningUnitId() {
      return Number.parseInt(this.$route.params.learningUnitId);
    },

    learningUnit() {
      return LearningUnit.query()
        .with('ultimate_learning_outcome')
        .whereId(this.learningUnitId)
        .first();
    },

    defaultSection() {
      return Section.query()
        .where('learning_unit_id', this.learningUnitId)
        .where('is_default', true)
        .first();
    },

    breadcrumbs() {
      const { learningUnit } = this;

      const { $route } = this;

      const breadcrumb = [
        {
          key: 'user-dashboard',
          name: 'User Dashboard',
          to: {
            name: 'user-dashboard'
          }
        },
        {
          key: 'micro-credentials-detail',
          name: learningUnit ? learningUnit.name : '',
          to: {
            name: 'micro-credentials/detail',
            params: {
              learningUnitId: learningUnit ? learningUnit.id : null
            }
          }
        }
      ];

      if ($route.name === 'learning-unit/verify') {
        breadcrumb.push({
          key: 'verify',
          name: 'Verify',
          active: true
        });
      }

      if ($route.name === 'learning-unit/feed') {
        breadcrumb.push({
          key: 'learning-feed',
          name: 'Learning',
          active: true
        });
      }

      return breadcrumb;
    },

    isPageVerifyCompetency() {
      return this.$route.name === 'learning-unit/verify';
    },

    pageSubmitEvidence() {
      return {
        name: 'learning-unit/evidence/submit',
        params: {
          learningUnitId: this.learningUnit.id
        }
      };
    },

    pageLearningFeed() {
      return {
        name: 'learning-unit/feed',
        params: {
          learningUnitId: this.learningUnit.id,
          sectionId: this.defaultSection.id
        }
      };
    },

    variantButtonPageSubmitEvidence() {
      const variant =
        this.$route.name === 'learning-unit/evidence/submit' ? 'first' : 'outline-first';
      return variant;
    },

    variantButtonPageLearningFeed() {
      const variant = this.$route.name === 'learning-unit/feed' ? 'first' : 'outline-first';

      return variant;
    },

    applied() {
      return Application.query()
        .where((apply) => {
          return apply.user.id == this.userId && apply.learning_unit.id == this.learningUnitId;
        })
        .first();
    },

    isModeLearnVerify() {
      return this.applied ? this.applied.isModeLearnVerify : false;
    },

    // Added for "What would you do next?" section
    evidenceSubmissions() {
      const evidenceSubmissions = EvidenceSubmission.query()
        .where('learning_unit_id', this.learningUnitId)
        .where('user_id', this.userId)
        .get();

      return evidenceSubmissions;
    },

    canCreateNewSubmission() {
      return (
        this.evidenceSubmissions.every((es) => es.isDenied) &&
        this.applied?.remaining_submission > 0
      );
    },

    isLearner() {
      // TODO: change condition to use something like enrollment instead
      return (
        !this.$currentUser.isRole('issuer') &&
        !this.$currentUser.isLearningUnitMemberOf(this.learningUnitId)
      );
    },

    latestSubmission() {
      if (this.evidenceSubmissions.length === 0) return null;

      return [...this.evidenceSubmissions].sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at);
      })[0];
    },

    showCardRemaining() {
      return (
        this.isLearner &&
        this.applied &&
        (this.applied.remaining_submission == 0 || !this.applied.remaining_submission) &&
        this.learningUnit &&
        this.isSubmissionPage &&
        !this.canCreateNewSubmission &&
        this.latestSubmission?.isDenied
      );
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler: 'onRouteChanged'
    }
  },
  methods: {
    goToSignInPageWithRedirect() {
      const previousRoute = this.$router.resolve({
        ...this.$route,
        params: {
          learningUnitId: this.learningUnitId
        }
      });

      this.$router.push({
        name: 'SignIn',
        query: {
          previousPath: previousRoute.href
        }
      });
    },

    async onRouteChanged() {
      if (!this.user) {
        this.goToSignInPageWithRedirect();
      } else {
        await this.fetchApply();
        if (!this.applied) {
          return this.$router.push({
            name: 'learning-unit'
          });
        }
        await this.fetch();
      }
    },

    async fetch() {
      try {
        await LearningUnit.api().fetchByLearningUnitId(this.learningUnitId);
      } catch (error) {
        this.$toast('Cannot load learning unit, please try again');
      }
    },

    async fetchApply() {
      if (!this.userId) return;
      try {
        await Application.api().find({
          user: this.userId,
          learning_unit: this.learningUnitId
        });
      } catch (error) {
        this.$toast('Cannot load application, please try again');
      }
    }

    // goToLearn() {
    //   this.$router.push({
    //     name: "learning-unit/feed",
    //     params: {
    //       learningUnitId: this.learningUnitId,
    //       sectionId: this.defaultSection.id,
    //     },
    //     query: {
    //       tab: "posts",
    //     },
    //   });
    // },
  }
};
</script>

<style scoped>
.page-index {
  background-color: #eceef7;
  margin-top: -24px;

  min-height: calc(100dvh - 72px);
}
.btn__start-learning {
  max-width: 248px;
  width: 100%;
}

@media screen and (min-width: 1200px) {
  .page-index {
    min-height: calc(100dvh - 76px);
  }
}
</style>
